import React from 'react';
import { motion } from 'framer-motion';

const MissionSection = () => {
  return (
    <section className="section" data-testid="mission-section">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          {/* Title */}
          <motion.div 
            className="md:col-span-4"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <span className="text-xs font-mono tracking-[0.2em] uppercase text-neutral-500">
              01
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight uppercase mt-4 text-white">
              Mission Statement
            </h2>
          </motion.div>
          
          {/* Content */}
          <motion.div 
            className="md:col-span-8"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          >
            <p className="text-xl md:text-2xl text-white font-semibold" data-testid="mission-text">
              AI for everyone.
            </p>
            <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mt-6">
              Not AI for the technically capable. Not AI for those who can afford a subscription. Not AI for the young, the able-bodied, or the already connected.
            </p>
            <p className="text-xl md:text-2xl text-white font-semibold mt-6">
              AI for everyone.
            </p>
            <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mt-6">
              We believe technology should disappear into the experience it enables — leaving only the magic behind. The family anywhere in the world who gets access to tools that were previously reserved for those with deeper pockets.
            </p>
            <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mt-6">
              We build things that are simple to use and quietly sophisticated underneath. We charge fairly for what people actually use. We never hold anyone's data hostage. And we never stop asking whether what we're building works for absolutely everyone who might need it or want it.
            </p>
            <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mt-6">
              That is what it means to be Simply Smarter.
            </p>
            <p className="text-xl md:text-2xl text-white font-semibold mt-8 tracking-wide">
              Simply Smarter. It's Simply Magic.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
